<template>
    <!-- 内容 -->
    <div class="All" user-scalable=no>
        <div class="contain">
            <div class="index">
                <div class="picture">
                    <img src="../assets/image/background.png" alt="" />
                </div>
                <div class="content">
                    <div>
                        <p>灵动配音</p>
                    </div>
                    <div class="textIntro">
                        <div>多种音色</div>
                        <div style="margin-left: 20px;"> | </div>
                        <div style="margin-left: 20px;">高度拟人</div>
                        <div style="margin-left: 20px;"> | </div>
                        <div style="margin-left: 20px;">功能丰富</div>
                    </div>
                    <div style="font-size: 20px;">一键智能转换，流畅自然的文字转语音工具</div>
                    <img src="../assets/image/code.jpg" alt="" class="code" />


                    <div class="ability">
                        <div class="pic">
                            <img src="../assets/image/icon3.png" alt="">
                            <div class="noice">情感丰富</div>
                        </div>
                        <div class="pic">
                            <img src="../assets/image/icon2.png" alt="">
                            <div class="noice">操作便捷</div>
                        </div>
                        <div class="pic">
                            <img src="../assets/image/icon1.png" alt="">
                            <div class="noice">音色繁多</div>
                        </div>
                        <div class="pic">
                            <img src="../assets/image/icon0.png" alt="">
                            <div class="noice">高效配音</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="function">
                <h1>八大功能 高效助力</h1>
                <div class="moduleAll">
                    <div class="module">
                        <div class="one">
                            <img src="../assets/image/icon1.png" alt="" class="icon">
                            <h3>智能配音</h3>
                            <p class="text">支持单人、多人配音，百种高度拟人、流畅自然的人声一键应用，操作简单</p>
                        </div>
                    </div>
                    <div class="module">
                        <div class="one">
                            <img src="../assets/image/icon1.png" alt="" class="icon">
                            <h3>智能配音</h3>
                            <p class="text">支持单人、多人配音，百种高度拟人、流畅自然的人声一键应用，操作简单</p>
                        </div>
                    </div>
                    <div class="module">
                        <div class="one">
                            <img src="../assets/image/icon1.png" alt="" class="icon">
                            <h3>智能配音</h3>
                            <p class="text">支持单人、多人配音，百种高度拟人、流畅自然的人声一键应用，操作简单</p>
                        </div>
                    </div>
                    <div class="module">
                        <div class="one">
                            <img src="../assets/image/icon1.png" alt="" class="icon">
                            <h3>智能配音</h3>
                            <p class="text">支持单人、多人配音，百种高度拟人、流畅自然的人声一键应用，操作简单</p>
                        </div>
                    </div>
                </div>
            </div> -->
            <!-- ------------------------------------------- -->
            <!-- <div class="product">
                <div class="h1">
                    <h1>软件介绍</h1>
                </div> -->
            <!-- <div class="product-all">
                    <div class="product-one">
                        <div style="font-size: 30px;margin-bottom: 30px;">多种音色选择</div>
                        <div style="color: #66b1ff;font-size: 20px;margin-bottom: 30px;">普通话、外语、方言自由切换</div>
                        <div style="font-size: 20px;">支持中文、英文、方言等语言的配音，近百种逼真人声、多样化背景音供您选择，拥有个性化的声音</div>
                        <el-button type="primary" @click="download">免费下载</el-button>

                    </div>
                    <div class="product-two">
                        <img src="../assets/image/4.png" alt="">
                    </div>
                </div> -->
            <!-- </div> -->

            <!-- <div class="product" style="height: 800px;">
                <div class="h1"> -->
            <!-- <h1>软件介绍</h1> -->
            <!-- </div>
                <div class="product-all">
                    <div class="product-one">
                        <div style="font-size: 30px;margin-bottom: 30px;">多种音色选择</div>
                        <div style="color: #66b1ff;font-size: 20px;margin-bottom: 30px;">普通话、外语、方言自由切换</div>
                        <div style="font-size: 20px;">支持中文、英文、方言等语言的配音，近百种逼真人声、多样化背景音供您选择，拥有个性化的声音</div>
                        <el-button type="primary" @click="download">免费下载</el-button>
                    </div>
                    <div class="product-two">
                        <img src="../assets/image/4.png" alt="">
                    </div>
                </div>
            </div>  -->
            <div>
                <el-dialog :title="title" :visible.sync="open" width="400px" append-to-body>
                    <img src="../assets/image/4.png" alt="">
                </el-dialog>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'contain',
    props: {
    },
    data() {
        return {
            // 是否显示弹出层
            open: false,
            title: "使用微信扫一扫使用本程序"
        };
    },
    created() {

    },
    methods: {
        download() {
            this.open = true
        }
    }
}
</script>

<style scoped lang="less">
.code {
    width: 258px;
    height: auto;
    margin-top: 50px;
}

img {
    width: 100%;
    height: auto;
}

.All {
    width: 100%;

    .contain {
        width: 1900px;
        margin-left: auto;
        margin-right: auto;
    }
}

.function {
    margin-top: 130px;
    text-align: center;

    .moduleAll {
        display: flex;
        justify-content: center;

        .module {
            width: 270px;
            height: 260px;
            background-color: #ffffff;
            border-radius: 5%;
            margin-top: 130px;
            box-shadow: 0px 2px 10px 1px rgba(0, 0, 0, 0.1);
            margin-left: 30px;

            .one {
                h3 {
                    line-height: 50px;

                }

                .icon {
                    width: 50px;
                    height: 50px;
                    margin-top: 35px;
                }

                .text {
                    line-height: 20px;
                    margin-top: 10px;
                    font-size: 15px;
                    padding-left: 8px;
                    padding-right: 8px;
                }
            }
        }

        // 向上的动画
        .module:hover {
            animation: moveUp 0.3s forwards;
            /* 应用动画 */
            opacity: 1;
        }

        /* 应用动画 */
        @keyframes moveUp {
            0% {
                transform: translateY(0);
            }

            100% {
                transform: translateY(-10px);
            }
        }
    }

}

.product {
    margin-top: 130px;
}

.index {
    position: relative;
    text-align: center;

    .content {
        position: absolute;
        top: 10%;
        left: 29%;

        p {
            font-size: 52px;
            margin-bottom: 20px;
        }
    }

    .textIntro {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;

    }

    .ability {
        width: 800px;
        display: flex;
        justify-content: space-around;
        margin-top: 60px;

        .pic {

            img {
                width: 90px;
                height: 90px;
            }

            .noice {
                font-size: 22px;
                margin-top: 15px;
                font-weight: 600;
            }
        }

        // 向上的动画
        .pic:hover {
            animation: moveUp 0.3s forwards;
            /* 应用动画 */
            opacity: 1;
        }

        /* 应用动画 */
        @keyframes moveUp {
            0% {
                transform: translateY(0);
            }

            100% {
                transform: translateY(-10px);
            }
        }
    }
}

button {
    width: 280px;
    height: 60px;
    margin-top: 60px;
    font-size: 20px;
}

.product {
    width: 100%;
    height: 600px;

    .h1 {
        text-align: center;
    }

    .product-all {
        display: flex;
        justify-content: center;
        // margin-top: 80px;

        .product-one {
            width: 700px;
            height: 470px;
            margin-top: 100px;
            padding-right: 30px;
        }

        .product-two {
            width: 700px;
            height: 470px;

            img {
                width: 100%;
                height: 470px;
            }

        }
    }

}
</style>